export const PROJECT_TYPE = {
  icon: {
    Rest: 'rest-api',
    WebApplication: 'web',
    MobileWeb: 'mobile-web',
    AndroidNative: 'android',
    IOSNative: 'ios',
    WINDOWS: 'windows-lite',
    Mutliple: 'nav-bar-menu',
    Salesforce: 'salesforce',
    WINDOWS_ADVANCED: 'desktop-windows',
  },
  text: {
    Rest: 'REST API Testing ',
    WebApplication: 'Web Application',
    MobileWeb: 'Mobile Web Application',
    AndroidNative: 'Android Native App',
    IOSNative: 'IOS Native App',
    WINDOWS: 'Windows Lite',
    WINDOWS_ADVANCED: 'WINDOWS_ADVANCED',
  },
};

export const PROJECTS_INFINITE_QUERY_KEY = 'projects-infinite-query';
export const PROJECTS_QUERY_KEY = 'projects-query';

export const APPLICATIONS_INFINITE_QUERY_KEY = 'applications-infinite-query';
export const APPLICATIONS_QUERY_KEY = 'applications-query';

export const VERSIONS_INFINITE_QUERY_KEY = 'versions-infinite-query';
export const VERSIONS_QUERY_KEY = 'versions-query';

export const TEST_CASE_QUERY_KEY = 'test-case-query';
export const TEST_CASE_ALL_QUERY_KEY = 'test-all-case-query';

export const REQUIREMENT_TYPES_QUERY_KEY = 'requirement-types-query';
export const REQUIREMENT_ALL_QUERY_KEY = 'requirement-all-query';

export const USER_PROJECT_MAPPING_KEY = 'user-project-mapping';

export const USERS_QUERY_KEY = 'users-query';
